import { ReactNode, useCallback, useMemo } from 'react';

import { AsyncQueue } from '@ui-furniture/lib/utils/async-queue';
import { calculateTimeToTypeText } from '@ui-furniture/lib/utils/calculate-time-to-type-text';
import { delay } from '@ui-furniture/lib/utils/delay';

import { ChatState } from '../types/chat-state';

export const useChatStateWithDelays = (chatState: ChatState): ChatState => {
  const queue = useMemo(() => new AsyncQueue(), []);

  const setTypingText = useCallback((text: string) => {
    queue.push(async () => {
      chatState.internalState.setIsTyping(true);
      const delayMs = calculateTimeToTypeText(text, {
        maxMs: 1000,
      });
      await delay(delayMs);
      chatState.internalState.setIsTyping(false);
    });
  }, []);

  const pushBotMessage = useCallback((text: string) => {
    setTypingText(text);
    queue.push(async () => {
      chatState.controls.pushBotMessage(text);
    });
  }, []);

  const setInput = useCallback((input: ReactNode) => {
    queue.push(async () => {
      await delay(200);
      chatState.controls.setInput(input);
    });
  }, []);
  const processUserResponse = useCallback<
    typeof chatState.controls.processUserResponse
  >((message) => {
    queue.push(async () => {
      chatState.controls.processUserResponse(message);
    });
  }, []);

  return {
    ...chatState,
    controls: {
      setInput,
      pushBotMessage,
      processUserResponse,
    },
  };
};
